module.exports = __webpack_public_path__ + "img/radio-empty.4fa53054.svg";